import { Button, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';

import { trpc } from '../../../../../services/trpc';

interface CancelSignatureRequestButtonProps {
  documentId: string;
  onSuccess?: () => void;
  label?: string;
}

export function CancelSignatureRequestButton({
  documentId,
  onSuccess = () => {},
  label = 'Annuler la demande de signature',
}: CancelSignatureRequestButtonProps) {
  const cancelSignatureRequest =
    trpc.documents.cancelSignatureRequest.useMutation();

  const handleCancelSignatureRequest = () => {
    modals.openConfirmModal({
      title: "Confirmation d'annulation",
      children: (
        <Text size="sm">
          Êtes-vous sûr de vouloir annuler cette demande de signature ?
        </Text>
      ),
      labels: { confirm: 'Annuler la signature', cancel: 'Retour' },
      onConfirm: async () => {
        try {
          await cancelSignatureRequest.mutateAsync({
            documentId,
          });
          notifications.show({
            title: 'Succès',
            message: 'La demande de signature a été annulée avec succès',
            color: 'green',
          });
          onSuccess();
        } catch {
          // Refresh document status after cancellation
          notifications.show({
            title: 'Erreur',
            message: "Impossible d'annuler la demande de signature",
            color: 'red',
          });
        }
      },
    });
  };

  return (
    <Button
      variant="outline"
      leftSection={<IconX size={16} />}
      loading={cancelSignatureRequest.isPending}
      onClick={handleCancelSignatureRequest}
      disabled={cancelSignatureRequest.isPending}
    >
      {label}
    </Button>
  );
}
